import {buildRequest} from '../stateUtil';
import {LOAD_LOGIN_PAGE_CONFIG} from './loginPageConfigActionTypes';

export const getLoginPageConfig = () =>
  buildRequest(LOAD_LOGIN_PAGE_CONFIG, 'GET', '/loginPageConfig');
